<div class="dialog-viewer">
    <h2 mat-dialog-title>Process Refund</h2>

    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-dialog-content>
            <div class="row">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            </div>
            <div class="container-fluid">
                <!-- Booking Details Section -->
                <div class="row mb-3">
                    <div class="col-12">
                        <mat-card>
                            <mat-card-content>
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <span class="font-weight-bold">Customer:</span>
                                    <span>{{bookingRefund?.customerName}}</span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <span class="font-weight-bold">Booking Total:</span>
                                    <span>${{bookingRefund?.totalPrice.toFixed(2)}}</span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="font-weight-bold">Payment Method:</span>
                                    <span><strong>{{paymentMethod?.card?.brand.toUpperCase()}}</strong> ending in {{paymentMethod?.card?.last4}}</span>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <!-- Refund Options Section -->
                <div class="row mb-3">
                    <div class="col-12">
                        <mat-checkbox formControlName="isPartialRefund" [disabled]="isLoading" (change)="onPartialRefundChange($event)">
                            Partial Refund
                        </mat-checkbox>
                    </div>
                </div>

                <!-- Add this before the Refund Amount section -->
                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Status</mat-label>
                            <mat-select required formControlName="status">
                                <mat-option *ngFor="let status of bookingStatusEnumKeys"
                                    [value]="bookingStatusEnum[status]">
                                    <ng-container
                                        *ngIf="status === bookingStatusEnum[3]">Closed/Maintenance</ng-container>
                                    <ng-container *ngIf="status !== bookingStatusEnum[3]">{{ status }}</ng-container>
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('status').errors?.required">Status is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Refund Amount -->
                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Refund Amount</mat-label>
                            <input matInput type="number" formControlName="refundAmount"
                                [readonly]="!form.get('isPartialRefund').value" [max]="bookingRefund?.totalPrice"
                                [step]="0.01">
                            <span matPrefix>$ &nbsp;</span>
                            <mat-error *ngIf="form.get('refundAmount').errors?.required">
                                Refund amount is required
                            </mat-error>
                            <mat-error *ngIf="form.get('refundAmount').errors?.min">
                                Refund amount must be greater than 0
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Refund Reason -->
                <div class="row mb-3">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                            <mat-label>Reason for Refund</mat-label>
                            <textarea matInput formControlName="reason" rows="3"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions>
            <button mat-raised-button type="submit" [disabled]="!form.valid || isLoading">Process
                Refund</button>
            <button mat-raised-button type="button" class="warning" [disabled]="isLoading" (click)="dialogRef.close('cancel')">Cancel</button>
        </mat-dialog-actions>
    </form>
</div>